import { avatarStore } from 'entities/avatar';
import { canvasStore } from 'entities/canvas';
import { videoStore } from 'entities/video';
import { voiceStore } from 'entities/voice';
import { useState } from 'react';
import { DEFAULT_FEMALE_VOICE } from 'shared/config';
import { Modal, OutlineButton, PrimaryButton } from 'shared/ui';

export const ClearProject = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { resetStore: resetAvatarStore } = avatarStore((state) => ({
    resetStore: state.resetStore
  }));
  const { resetStore: resetCanvasStore } = canvasStore((state) => ({
    resetStore: state.resetStore
  }));

  const { resetStore: resetVideoStore } = videoStore((state) => ({
    resetStore: state.resetStore
  }));

  const { setDefaultVoice } = voiceStore((state) => ({
    setDefaultVoice: state.setDefaultVoice
  }));

  const resetStores = () => {
    resetAvatarStore();
    resetCanvasStore();
    resetVideoStore();
    setDefaultVoice(DEFAULT_FEMALE_VOICE);
  };
  return (
    <>
      <button
        onClick={() => setIsModalOpen(true)}
        className="yep_ex-flex yep_ex-items-center yep_ex-gap-2"
      >
        Clear
      </button>
      {isModalOpen && (
        <Modal
          open={isModalOpen}
          onClose={setIsModalOpen}
          withCloseButton
          className="md:yep_ex-max-w-[400px]"
        >
          <h3 className="yep_ex-text-lg yep_ex-font-inter yep_ex-font-semibold yep_ex-text-gray-900">
            Clear Project
          </h3>
          <span className="yep_ex-text-gray-600 yep_ex-text-sm">
            Are you sure you want to clear the project?
          </span>
          <div className="yep_ex-flex yep_ex-justify-between yep_ex-items-center yep_ex-gap-3 yep_ex-mt-8">
            <OutlineButton
              className="yep_ex-w-1/2 focus:yep_ex-outline-primary-600"
              onClick={() => setIsModalOpen(false)}
            >
              Cancel
            </OutlineButton>
            <PrimaryButton
              type="button"
              className="yep_ex-w-1/2 focus:yep_ex-outline-white yep_ex-flex yep_ex-justify-center yep_ex-items-center yep_ex-bg-red-600 hover:yep_ex-bg-red-700"
              onClick={() => {
                resetStores();
                setIsModalOpen(false);
              }}
            >
              Clear
            </PrimaryButton>
          </div>
        </Modal>
      )}
    </>
  );
};
